import React from 'react';
import RouteComponent from './Routes';

function App() {
  return (
    <RouteComponent />
  );
}

export default App;